import get from 'lodash.get';
import isEqual from 'lodash.isequal';

import type { DependenciesFormValues } from '../../types/FormValues';
import type { FieldDependsOnDescriptor } from '../../fields/types/common';

export const checkDependencyChanged = (
  dependency: FieldDependsOnDescriptor,
  prevDependencyValues: DependenciesFormValues,
  currentDependencyValues: DependenciesFormValues,
  sectionKey: string
): boolean => {
  if ('$or' in dependency) {
    return dependency.$or.some((dep) =>
      checkDependencyChanged(dep, prevDependencyValues, currentDependencyValues, sectionKey)
    );
  }
  if ('$and' in dependency) {
    return dependency.$and.some((dep) =>
      checkDependencyChanged(dep, prevDependencyValues, currentDependencyValues, sectionKey)
    );
  }
  if ('sectionKey' in dependency && 'fieldKey' in dependency) {
    const path = [dependency.sectionKey, ...dependency.fieldKey.split('.')];
    const prevValue = get(prevDependencyValues, path);
    const currentValue = get(currentDependencyValues, path);
    return !isEqual(prevValue, currentValue);
  }
  if ('sectionKey' in dependency) {
    const prevValue = prevDependencyValues[dependency.sectionKey];
    const currentValue = currentDependencyValues[dependency.sectionKey];
    return !isEqual(prevValue, currentValue);
  }
  if ('fieldKey' in dependency) {
    const path = [...dependency.fieldKey.split('.')];
    const prevValue = get(prevDependencyValues, path);
    const currentValue = get(currentDependencyValues, path);
    return !isEqual(prevValue, currentValue);
  }
  if ('all' in dependency) {
    return !isEqual(prevDependencyValues, currentDependencyValues);
  }

  return false;
};
